import React, { useCallback, useMemo } from "react";
import { Form } from "react-final-form";
import { FormattedMessage } from "react-intl";
import { Button } from "reactstrap";
import { TextInput } from "src/shared/forms/inputs/TextInputNew";
import "src/subscribers/components/SubscriberSearchForm.css";

export interface SearchFormProps {
  value: string | null;
  onUpdate: (value: string | null) => void;
}

interface SearchFormValues {
  value: string | null | undefined;
}

export const SearchForm = ({ value, onUpdate }: SearchFormProps) => {
  const initialValues = useMemo<SearchFormValues>(() => ({ value }), [value]);

  const handleFormSubmit = useCallback(
    (values: SearchFormValues) => {
      onUpdate(values.value ?? null);
    },
    [onUpdate],
  );

  return (
    <Form<SearchFormValues>
      onSubmit={handleFormSubmit}
      initialValues={initialValues}
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className="subscriber-search-form">
          <TextInput<SearchFormValues>
            inputID="value"
            label={<FormattedMessage id="subscribers.search.term" />}
            isRequired={false}
          />
          <Button type="submit" color="primary">
            <i className="fas fa-search" />
          </Button>
        </form>
      )}
    </Form>
  );
};
